<div class="mentions-toolbar" data-cy="my-mentions">
	<div class="mentions-toolbar-copy">
		<div class="mentions-toolbar-title">
			Select mentions to remove
		</div>

		<div
			*ngIf="selectedMentions.length > 0"
			class="mentions-toolbar-selection"
		>
			{{ selectedMentions.length }}
			{{
				selectedMentions.length === 1
					? 'mention selected'
					: 'mentions selected'
			}}
		</div>
	</div>

	<button
		pButton
		type="button"
		icon="pi pi-check"
		label="Remove Selected"
		class="p-button-primary"
		[disabled]="selectedMentions.length === 0 || isRemovingMentions"
		(click)="deleteSelected()"
	></button>
</div>

<div *ngIf="isLoading" class="dashboard-state">
	<p-progressSpinner
		[style]="{ width: '28px', height: '28px' }"
		strokeWidth="4"
	></p-progressSpinner>

	<span>Loading mentions...</span>
</div>

<div
	*ngIf="!isLoading && isRemovingMentions"
	class="dashboard-state"
>
	<p-progressSpinner
		[style]="{ width: '28px', height: '28px' }"
		strokeWidth="4"
	></p-progressSpinner>

	<span>Removing selected mentions...</span>
</div>

<div
	*ngIf="!isLoading && !isRemovingMentions"
	class="mentions-table-wrapper"
>
	<p-table
		data-cy="mentions-table"
		[value]="mentions"
		[(selection)]="selectedMentions"
		[paginator]="true"
		[rows]="20"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
		dataKey="id"
		selectionMode="multiple"
		styleClass="dashboard-data-table"
	>
		<ng-template pTemplate="header">
			<tr>
				<th class="selection-column">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<th pSortableColumn="createdDate">
					Mentioned
					<p-sortIcon field="createdDate"></p-sortIcon>
				</th>

				<th pSortableColumn="dueDate">
					Due Date
					<p-sortIcon field="dueDate"></p-sortIcon>
				</th>

				<th pSortableColumn="workflowName">
					Task
					<p-sortIcon field="workflowName"></p-sortIcon>
				</th>

				<th pSortableColumn="commentText">
					Comment
					<p-sortIcon field="commentText"></p-sortIcon>
				</th>

				<th pSortableColumn="readDate">
					Status
					<p-sortIcon field="readDate"></p-sortIcon>
				</th>

				<th class="action-column">
					Action
				</th>
			</tr>
		</ng-template>

		<ng-template let-mention pTemplate="body">
			<tr>
				<td class="selection-column">
					<p-tableCheckbox [value]="mention"></p-tableCheckbox>
				</td>

				<td class="date-column">
					{{
						mention.createdDate
							| DatePropertyTimezone: false : true
					}}
				</td>

				<td class="date-column">
					{{
						mention.dueDate
							| DatePropertyTimezone: false : true
					}}
				</td>

				<td class="mention-task">
					{{ mention.workflowName }}
				</td>

				<td class="mention-comment">
					{{ mention.commentText }}
				</td>

				<td>
					<span
						*ngIf="!mention.readDate"
						class="mention-status mention-status-unread"
					>
						Unread
					</span>

					<span
						*ngIf="mention.readDate"
						class="mention-status mention-status-read"
					>
						Read
					</span>
				</td>

				<td class="action-column">
					<button
						type="button"
						class="mention-view-link"
						title="Go to task"
						(click)="goToMention(mention, $event)"
					>
						<span>View</span>
						<i class="pi pi-arrow-right"></i>
					</button>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="7">
					<div class="dashboard-empty-state">
						<i class="pi pi-check-circle"></i>
						<span>No mentions</span>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
